import React from 'react';
import { Box, Typography } from '@mui/material';

const LockedArea = ({ locked, message, children }) => (
  <Box className="clube-locked-area">
    {locked ? (
      <Box className="clube-locked-overlay">
        <Typography variant="body2" className="clube-locked-message">
          {message}
        </Typography>
      </Box>
    ) : null}
    <Box className={locked ? 'clube-locked-content--disabled' : undefined}>
      {children}
    </Box>
  </Box>
);

export default LockedArea;
